import { createAction, props } from '@ngrx/store';
import { AppError } from '../../errors/app-error';
import { CommonIdGetDesiredUniversitiesRequest } from 'src/app/models/common-id/common-id-get-desired-universities-request';
import { CommonIdGetDesiredUniversitiesResponse } from 'src/app/models/common-id/common-id-get-desired-universities-response';

/* 最新の志望校の取得処理 */
export const commonIdGetDesiredUniversities = createAction(
  '[CommonIdGetDesiredUniversities] Common Id Get Desired Universities',
  props<{ request: CommonIdGetDesiredUniversitiesRequest }>()
);
export const commonIdGetDesiredUniversitiesSuccess = createAction(
  '[CommonIdGetDesiredUniversities] Common Id Get Desired Universities Success',
  props<{ response: CommonIdGetDesiredUniversitiesResponse }>()
);
export const commonIdGetDesiredUniversitiesFailure = createAction(
  '[CommonIdGetDesiredUniversities] Common Id Get Desired Universities Failure',
  props<{ error: AppError }>()
);
export const initializeCommonIdGetDesiredUniversitiesResult = createAction('[CommonIdAuth] Initialize Get Desired Universities Result');
